/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComputedCommunicationPreferences } from './ComputedCommunicationPreferences';
import {
    ComputedCommunicationPreferencesFromJSON,
    ComputedCommunicationPreferencesFromJSONTyped,
    ComputedCommunicationPreferencesToJSON,
    ComputedCommunicationPreferencesToJSONTyped,
} from './ComputedCommunicationPreferences';

/**
 * 
 * @export
 * @interface GetMyExtendedProfileResponse
 */
export interface GetMyExtendedProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    email: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMyExtendedProfileResponse
     */
    roles: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    countryState?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    timezone?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMyExtendedProfileResponse
     */
    allowedMlsProvidersLabels: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMyExtendedProfileResponse
     */
    allowedMlsProviders: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMyExtendedProfileResponse
     */
    enabledMlsProviders?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMyExtendedProfileResponse
     */
    allowedChatInterfaces: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMyExtendedProfileResponse
     */
    allowedStates: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    officeName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    mlsId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    subscriptionPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    trackingId: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    hash: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    createdOn: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    subscriptionStatus: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMyExtendedProfileResponse
     */
    subscriptionPlanTier?: GetMyExtendedProfileResponseSubscriptionPlanTierEnum;
    /**
     * 
     * @type {ComputedCommunicationPreferences}
     * @memberof GetMyExtendedProfileResponse
     */
    communicationPreferences: ComputedCommunicationPreferences;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMyExtendedProfileResponse
     */
    modules: Array<string>;
}


/**
 * @export
 */
export const GetMyExtendedProfileResponseSubscriptionPlanTierEnum = {
    Basic: 'basic',
    Pro: 'pro'
} as const;
export type GetMyExtendedProfileResponseSubscriptionPlanTierEnum = typeof GetMyExtendedProfileResponseSubscriptionPlanTierEnum[keyof typeof GetMyExtendedProfileResponseSubscriptionPlanTierEnum];


/**
 * Check if a given object implements the GetMyExtendedProfileResponse interface.
 */
export function instanceOfGetMyExtendedProfileResponse(value: object): value is GetMyExtendedProfileResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('allowedMlsProvidersLabels' in value) || value['allowedMlsProvidersLabels'] === undefined) return false;
    if (!('allowedMlsProviders' in value) || value['allowedMlsProviders'] === undefined) return false;
    if (!('allowedChatInterfaces' in value) || value['allowedChatInterfaces'] === undefined) return false;
    if (!('allowedStates' in value) || value['allowedStates'] === undefined) return false;
    if (!('trackingId' in value) || value['trackingId'] === undefined) return false;
    if (!('hash' in value) || value['hash'] === undefined) return false;
    if (!('createdOn' in value) || value['createdOn'] === undefined) return false;
    if (!('subscriptionStatus' in value) || value['subscriptionStatus'] === undefined) return false;
    if (!('communicationPreferences' in value) || value['communicationPreferences'] === undefined) return false;
    if (!('modules' in value) || value['modules'] === undefined) return false;
    return true;
}

export function GetMyExtendedProfileResponseFromJSON(json: any): GetMyExtendedProfileResponse {
    return GetMyExtendedProfileResponseFromJSONTyped(json, false);
}

export function GetMyExtendedProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMyExtendedProfileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'roles': json['roles'],
        'countryState': json['countryState'] == null ? undefined : json['countryState'],
        'country': json['country'] == null ? undefined : json['country'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'allowedMlsProvidersLabels': json['allowedMlsProvidersLabels'],
        'allowedMlsProviders': json['allowedMlsProviders'],
        'enabledMlsProviders': json['enabledMlsProviders'] == null ? undefined : json['enabledMlsProviders'],
        'allowedChatInterfaces': json['allowedChatInterfaces'],
        'allowedStates': json['allowedStates'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'subscriptionPlanId': json['subscriptionPlanId'] == null ? undefined : json['subscriptionPlanId'],
        'trackingId': json['trackingId'],
        'hash': json['hash'],
        'createdOn': json['createdOn'],
        'subscriptionStatus': json['subscriptionStatus'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
        'subscriptionPlanTier': json['subscriptionPlanTier'] == null ? undefined : json['subscriptionPlanTier'],
        'communicationPreferences': ComputedCommunicationPreferencesFromJSON(json['communicationPreferences']),
        'modules': json['modules'],
    };
}

export function GetMyExtendedProfileResponseToJSON(json: any): GetMyExtendedProfileResponse {
    return GetMyExtendedProfileResponseToJSONTyped(json, false);
}

export function GetMyExtendedProfileResponseToJSONTyped(value?: GetMyExtendedProfileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'roles': value['roles'],
        'countryState': value['countryState'],
        'country': value['country'],
        'timezone': value['timezone'],
        'allowedMlsProvidersLabels': value['allowedMlsProvidersLabels'],
        'allowedMlsProviders': value['allowedMlsProviders'],
        'enabledMlsProviders': value['enabledMlsProviders'],
        'allowedChatInterfaces': value['allowedChatInterfaces'],
        'allowedStates': value['allowedStates'],
        'officeName': value['officeName'],
        'mlsId': value['mlsId'],
        'phoneNumber': value['phoneNumber'],
        'subscriptionPlanId': value['subscriptionPlanId'],
        'trackingId': value['trackingId'],
        'hash': value['hash'],
        'createdOn': value['createdOn'],
        'subscriptionStatus': value['subscriptionStatus'],
        'avatar': value['avatar'],
        'subscriptionPlanTier': value['subscriptionPlanTier'],
        'communicationPreferences': ComputedCommunicationPreferencesToJSON(value['communicationPreferences']),
        'modules': value['modules'],
    };
}

